// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Cr-z","imageAndVideoCount":"Dr-z","imageAndVideoContainer":"Er-z","viewAllReviews":"Fr-z"};